namespace TabAurous.Production {
    export interface IssueMaterialDetailsForm {
        DepartmentId: Serenity.LookupEditor;
        BagNo: Serenity.StringEditor;
        SubBagNo: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        Attribute: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        Line_No: Serenity.StringEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        RequiredPieces: Serenity.IntegerEditor;
        RequiredWeight: Serenity.DecimalEditor;
        ItemDetails: IssueMaterialItemsEditor;
    }

    export class IssueMaterialDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Production.IssueMaterialDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IssueMaterialDetailsForm.init)  {
                IssueMaterialDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DecimalEditor;
                var w4 = IssueMaterialItemsEditor;

                Q.initFormType(IssueMaterialDetailsForm, [
                    'DepartmentId', w0,
                    'BagNo', w1,
                    'SubBagNo', w2,
                    'ProductId', w1,
                    'AttributeId', w1,
                    'Attribute', w1,
                    'ProductCode', w1,
                    'Line_No', w1,
                    'Pieces', w2,
                    'Weight', w3,
                    'RequiredPieces', w2,
                    'RequiredWeight', w3,
                    'ItemDetails', w4
                ]);
            }
        }
    }
}
